import React from 'react';
import { Segment } from 'semantic-ui-react'

class MonthBox extends React.Component {
    render() {
        const { name, active, number } = this.props;

        if (active) {
            return <Segment inverted color="green" className="lowPadding">
                <p className="mobile only">{number}</p>
                <p className="tablet computer large screen widescreen only">{name}</p>
            </Segment>;
        } else {
            return <Segment className="lowPadding">
                <p className="mobile only">{number}</p>
                <p className="tablet computer large screen widescreen only">{name}</p>
            </Segment>;
        }
    }
}

export default MonthBox;